import * as React from "react";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {Display} from "../../../components/Display";
import {EmptyState, icons} from "@vebox/etui-core";
import "./style.scss";
import {STATUS_TEXTS, StatusChip} from "../../components/StatusChip";
import {capitalizeFirstLetter, getFormattedDate} from "../../ReadAndWrite/utils";
import {CurrentSettingsUpdateResult} from "../../data/models/CurrentSettingsUpdateResult";

interface LastCampaignInfoProps {
    data: CurrentSettingsUpdateResult;
    isLoading: boolean;
    error: Error;
}

export const LastCampaignInfo: React.FC<LastCampaignInfoProps> = ({isLoading, data, error}) => {
    const {AppTranslations} = React.useContext(ReadAndWriteContext);

    const getStartedAt = () => {
        return AppTranslations.readAndWrite.configurationStartedAt
            .replace("{0}", data?.startedAt
                ? getFormattedDate({dateToFormat: data?.startedAt})
                : "-")
            .replace("{1}", data?.user);
    }

    const getConcludedAt = () => {
        const concluded = AppTranslations.readAndWrite.configurationEndedAt
            .replace("{0}", data?.concludedAt
                ? getFormattedDate({dateToFormat: data?.concludedAt})
                : "-")
        return `${data?.concludedAt ? concluded : ""}`;
    }

    return (
        <Display isVisible={!isLoading && !error && Object.keys(data).length > 0}>
            <VeBoxCard className={"rw-card"}>
                <VeBoxCard.Body className={"rw-card-body"}>
                    <Display isVisible={!isLoading && !error}>
                        <div className={"flx-row flx-space-between"}>
                            <h2 className={"last-campaign-info-title"}>{AppTranslations.readAndWrite.lastConfigurationUpdate}</h2>
                            <StatusChip status={capitalizeFirstLetter(data?.status) as STATUS_TEXTS}/>
                        </div>
                        <div className={"flx-row flx-space-between padding-top-10"}>
                            <p className={"last-campaign-info-footer"}>{getStartedAt()}</p>
                            <p className={"last-campaign-info-footer"}>{AppTranslations.readAndWrite.operationsPerformed}: {data?.numProcessed}/{data?.numExpected}</p>
                        </div>
                        <div className={"flx-row flx-space-between padding-top-10"}>
                            <p className={"last-campaign-info-footer"}>{getConcludedAt()}</p>
                            <p className={"last-campaign-info-footer"}>
                                <Display isVisible={data?.changes?.length > 0}>{data?.changes?.length} {AppTranslations.readAndWrite.changes}</Display>
                                <Display isVisible={data?.anomalies?.length > 0}>{data?.anomalies?.length} {AppTranslations.readAndWrite.error}</Display>
                            </p>
                        </div>
                    </Display>
                    <Display isVisible={error}>
                        <EmptyState>
                            <EmptyState.Icon size={144} glyph={icons.ERROR_CIRCLE}/>
                            <EmptyState.Title color="inherit">{AppTranslations.readAndWrite.errorLoadingConfiguration}</EmptyState.Title>
                            <EmptyState.SubTitle color="inherit">
                                {AppTranslations.errorMessages.tryAgainLaterMessage}
                            </EmptyState.SubTitle>
                        </EmptyState>
                    </Display>
                </VeBoxCard.Body>
            </VeBoxCard>
        </Display>
    );
}